import React, { useMemo } from 'react';

import classNames from 'classnames';

import { BulletList, HybridConnectInfo, SubContentComponent } from 'features/order-tracker/shared-components';
import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';

import { HYBRID_CONNECT_PRODUCT, SMART_HUB_2_PRODUCT, SMART_HUB_3_PRODUCT } from '../../../../constants';
import { DeliveriesTracking } from './components';
import { ESTIMATED_DELIVERY_SECTION, POST_DISPATCH_PRODUCT_TITLE, PRE_DISPATCH_PRODUCT_TITLE } from './constants';

import styles from './styles.module.scss';

export const DeliveryInfo: React.FC<components.DeliveryInfo> = ({ delivery, status }) => {
  const { products } = delivery;
  const smartHubProduct = useMemo(
    () =>
      (products.some((product) => product.includes(SMART_HUB_3_PRODUCT)) && SMART_HUB_3_PRODUCT) ||
      (products.some((product) => product.includes(SMART_HUB_2_PRODUCT)) && SMART_HUB_2_PRODUCT) ||
      (products.some((product) => product.includes(HYBRID_CONNECT_PRODUCT)) && HYBRID_CONNECT_PRODUCT) ||
      '',
    [products],
  );
  const isDispatched = status !== DELIVERY_STATUSES.ToBeSent;
  const multipleProductsPostfix = products.length > 1 ? 's' : '';
  const deliveryProductsTitle = isDispatched
    ? POST_DISPATCH_PRODUCT_TITLE
    : `Item${multipleProductsPostfix} ${PRE_DISPATCH_PRODUCT_TITLE}`;

  const hasHybridConnectInfo = isDispatched && !!smartHubProduct;

  return (
    <div className={classNames(styles.contentHolder, { [styles.withHybridConnect]: hasHybridConnectInfo })}>
      {isDispatched && <DeliveriesTracking delivery={delivery} status={status} />}
      <BulletList title={deliveryProductsTitle} list={products} listTestId="delivery-products-list" />
      {isDispatched ? (
        hasHybridConnectInfo && <HybridConnectInfo smartHubProduct={smartHubProduct} isDeliveryInProgress />
      ) : (
        <SubContentComponent title={ESTIMATED_DELIVERY_SECTION.title}>
          <p>{ESTIMATED_DELIVERY_SECTION.text}</p>
        </SubContentComponent>
      )}
    </div>
  );
};
